import moment from 'moment';
import 'moment/locale/fi';

// this updateLocale being called here means it's setting moment locale (same function as moment.setLocale) and updating the locale format.

moment.updateLocale('fi', {
  longDateFormat: {
    LT: 'HH.mm',
    LTS: 'HH.mm.ss',
    L: 'DD.MM.YYYY',
    LL: 'Do MMMM YYYY',
    LLL: 'Do MMMM YYYY, HH.mm',
    LLLL: 'dddd, Do MMMM YYYY, HH.mm',
    l: 'D.M.YYYY',
    ll: 'Do MMM YYYY',
    lll: 'Do MMM YYYY, HH.mm',
    llll: 'ddd, Do MMM YYYY, HH.mm',
  },
});

export const DATE_FORMAT = 'LL';

/**
 * Returns a formatted date string of given moment object
 * @param {Moment} m
 * @param {string} f
 * @returns {string} formatted date string
 */
export function getFormattedDateString(m, f) {
  return m.format(f || DATE_FORMAT);
}

/**
 * Creates moment object from momentInput
 * @param {Moment | Date | string | number} momentInput
 * @param {string} format of the input
 * @returns {Moment} moment object
 */
export function getMoment(momentInput, format) {
  return moment.utc(momentInput, format);
}

/**
 * Returns true when moment objects have same date when time is set to start of day.
 * @param {Moment} start
 * @param {Moment} end
 * @returns {boolean}
 */
export function isSameOnStartOfDay(start, end) {
  return start.startOf('day').isSame(end.startOf('day'));
}

export function getDuration(diff) {
  return moment.duration(diff);
}

/**
 * Sets moment locale to given locale
 * @param {string} locale
 */

export function updateLocale(locale) {
  moment.updateLocale(locale);
}

export function getDifferenceInDays(m1, m2) {
  return Math.abs(m1.diff(m2, 'days'));
}

export function getNow() {
  return moment.now();
}

export function getDateRangeString(start, end) {
  const startDate = moment(start).format('l');
  const endDate = moment(end).format('l');

  const isSameDate = isSameOnStartOfDay(moment(start), moment(end));
  if (isSameDate) {
    return `${startDate}`;
  }
  return `${startDate} - ${endDate}`;
}
